import { render } from "./PayVideoPlayerShell.vue?vue&type=template&id=78efe458&scoped=true"
import script from "./PayVideoPlayerShell.vue?vue&type=script&lang=js"
export * from "./PayVideoPlayerShell.vue?vue&type=script&lang=js"

import "./PayVideoPlayerShell.vue?vue&type=style&index=0&id=78efe458&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78efe458"]])

export default __exports__